<template>
  <b-row>
    <b-col
      lg="6"
      md="12"
      sm="12"
    >
      <b-card class="gradient-card">
        <div>
          <div class="d-flex flex-column justify-content-between">
            <div>
              <span style="font-size: 16px;">
                จำนวนคนข้ามทั้งหมด
              </span>
              <!-- <b-link :to="`/wim-table?wid=${this.$route.query.wid}`">
              <feather-icon
                icon="InfoIcon"
                size="20"
              />
            </b-link> -->
            </div>
            <div class="d-flex justify-content-between align-items-center mt-1">
              <b-img
                style="height: 30px; transform: translateY(-15px); visibility: hidden;"
                src="@/assets/images/icons/crosswalk/iconcc/Vector.png"
              />
              <span style="font-size: 26px;">
                {{ Total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}
                <span style="font-size: 18px; margin-left: 10px;">คน</span>
              </span>
              <b-img
                style="height: 30px; transform: translateY(-15px);"
                src="@/assets/images/icons/crosswalk/iconcc/Vector.png"
              />
            </div>
          </div>
        </div>
      </b-card>
    </b-col>
    <b-col
      lg="6"
      md="12"
      sm="12"
    >
      <b-card class="gradient-card">
        <div>
          <div class="d-flex flex-column justify-content-between">
            <div>
              <span style="font-size: 16px;">
                การกดปุ่มทั้งหมด
              </span>
            </div>
            <div class="d-flex justify-content-between align-items-center mt-1">
              <b-img
                style="height: 34px; transform: translateY(-15px); visibility: hidden;"
                src="@/assets/images/icons/crosswalk/iconcc/stop.png"
              />
              <span style="font-size: 26px;">
                {{ Button.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}
                <span style="font-size: 18px; margin-left: 10px;">ครั้ง</span>
              </span>
              <b-img
                style="height: 34px; transform: translateY(-15px);"
                src="@/assets/images/icons/crosswalk/iconcc/stop.png"
              />
            </div>
          </div>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow, BCol, BCard, BImg,
  // BLink,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import axios from '@axios'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BImg,
    // BLink,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      Total: '',
      Button: '',
    }
  },
  computed: {
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  mounted() {
    this.getDataCrosswalkScifi()
    this.interval = setInterval(() => {
      this.getDataCrosswalkScifi()
    }, 300000)
  },
  methods: {
    getDataCrosswalkScifi() {
      axios.post('/valueCrossWalk', { wid: this.$route.query.wid })
        .then(response => {
          this.Total = response.data[0].Total
          this.Button = response.data[0].Button
          // this.Unbutton = response.data[0].Unbutton
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.gradient-card {
  background:
    linear-gradient(to right, rgba(22, 60, 73, 1) 0%, rgba(22, 52, 73, 0.5) 25%, rgba(0,0,0,0) 50%, rgba(0, 111, 30, 0.0) 75%, rgba(0,0,0,0) 100%),
    linear-gradient(to left, rgba(22, 60, 73, 1) 0%, rgba(22, 52, 73, 0.5) 25%, rgba(0,0,0,0) 50%, rgba(0, 111, 30, 0.0) 75%, rgba(0,0,0,0) 100%),
    linear-gradient(to bottom, rgba(22, 60, 73, 0.5) 0%, rgba(22, 52, 73, 0.1) 20%, rgba(0,0,0,0) 50%, rgba(0, 111, 30, 0.0) 75%, rgba(0,0,0,0) 100%),
    linear-gradient(to top, rgba(22, 60, 73, 0.5) 0%, rgba(22, 52, 73, 0.1) 20%, rgba(0,0,0,0) 50%, rgba(0, 111, 30, 0.0) 75%, rgba(0,0,0,0) 100%);
  background-size: 100% 100%, 100% 100%, 100% 100%, 100% 100%;
  background-position: 0 0, 0 100%, 0 0, 100% 0;
  background-repeat: no-repeat;
  border: 1px solid rgb(30, 83, 100, 0.7);
}
// .gradient-card2 {
//   background:
//     linear-gradient(to right, rgb(73, 22, 22) 0%, rgba(73, 22, 22, 0.5) 25%, rgba(0,0,0,0) 50%, rgba(0, 111, 30, 0.0) 75%, rgba(0,0,0,0) 100%),
//     linear-gradient(to left, rgba(73, 22, 22, 1) 0%, rgba(73, 22, 22, 0.5) 25%, rgba(0,0,0,0) 50%, rgba(0, 111, 30, 0.0) 75%, rgba(0,0,0,0) 100%),
//     linear-gradient(to bottom, rgba(73, 22, 22, 0.5) 0%, rgba(73, 22, 22, 0.1) 20%, rgba(0,0,0,0) 50%, rgba(0, 111, 30, 0.0) 75%, rgba(0,0,0,0) 100%),
//     linear-gradient(to top, rgba(73, 22, 22, 0.5) 0%, rgba(73, 22, 22, 0.1) 20%, rgba(0,0,0,0) 50%, rgba(0, 111, 30, 0.0) 75%, rgba(0,0,0,0) 100%);
//   background-size: 100% 100%, 100% 100%, 100% 100%, 100% 100%;
//   background-position: 0 0, 0 100%, 0 0, 100% 0;
//   background-repeat: no-repeat;
//   border: 1px solid rgba(100, 30, 30, 0.7);
// }
// .gradient-card3 {
//   background:
//     linear-gradient(to right, rgb(22, 73, 27) 0%, rgba(25, 73, 22, 0.5) 25%, rgba(0,0,0,0) 50%, rgba(0, 111, 30, 0.0) 75%, rgba(0,0,0,0) 100%),
//     linear-gradient(to left, rgb(22, 73, 29) 0%, rgba(22, 73, 27, 0.5) 25%, rgba(0,0,0,0) 50%, rgba(0, 111, 30, 0.0) 75%, rgba(0,0,0,0) 100%),
//     linear-gradient(to bottom, rgba(26, 73, 22, 0.5) 0%, rgba(73, 22, 22, 0.1) 20%, rgba(0,0,0,0) 50%, rgba(0, 111, 30, 0.0) 75%, rgba(0,0,0,0) 100%),
//     linear-gradient(to top, rgba(25, 73, 22, 0.5) 0%, rgba(73, 22, 22, 0.1) 20%, rgba(0,0,0,0) 50%, rgba(0, 111, 30, 0.0) 75%, rgba(0,0,0,0) 100%);
//   background-size: 100% 100%, 100% 100%, 100% 100%, 100% 100%;
//   background-position: 0 0, 0 100%, 0 0, 100% 0;
//   background-repeat: no-repeat;
//   border: 1px solid rgba(31, 100, 30, 0.7);
// }
</style>
